import React from 'react'
import cx from 'classnames'
import './iOSPermissionPrompt.scss'

export const IOS_PERMISSION_TYPES = {
    audio: "audio"
}

export default function IOSPermissionPrompt({ type, onAccept, onReject, title, body, img, classes, tappedAllow }) {

    const containerClasses = cx({
        'ios-permission-prompt': true,
        'type-audio': type === IOS_PERMISSION_TYPES.audio
    })

    return (
        <div className={`${containerClasses} ${classes}`}>
            <div className='__inner'>
                <div className='__top-container'>
                    {title && <h2 className='__title'>{title}</h2>}
                    {body && <p className='__text'>{body}</p>}
                    {img && <div><img alt={title} src={img} /></div>}
                </div>
                <div className='__button-container'>
                    <button disabled={tappedAllow} className='__reject' onClick={onReject}>Cancel</button>
                    <button disabled={tappedAllow} className='__allow' onClick={onAccept}>Allow</button>
                </div>
            </div>
        </div>
    )
}
